export const generateUuid = () => crypto.randomUUID();
